const RoleEnum = {
  ADMIN: "admin",
  TENANT_ADMIN: "tenantAdmin",
  TENANT_USER: "tenantUser",
  COLLAB: "collab"
};

module.exports = RoleEnum;
